import { api, type Api } from "@api/bot-base-api-request";
import { useMutation } from "@tanstack/react-query";
import {
  NotificationParams,
  useNotification,
} from "@providers/notifications-bot-actions/notifications-bot-actions.tsx";

const BOT_LIMIT_SELL_QUERY_KEY = "bot-limit-sell";

type BotLimitSellParams = {
  appPubKey: string;
  userId: string;
  chainId: number;
  tokenAddress: string;
  walletAddress: string;
  amount: string | number;
  slippage?: number;
  triggerPrice: string | number;
};

type BotLimitSellInput = {
  params: BotLimitSellParams;
  notifyParams: NotificationParams;
};

const postBotLimitSell = async (api: Api, params: BotLimitSellParams) =>
  api.post("orders/limitSell", { json: params }).json();

const useBotLimitSellMutation = () => {
  const { setNotifyProps } = useNotification();

  return useMutation<unknown, Error, BotLimitSellInput>({
    mutationFn: async (input: BotLimitSellInput) =>
      postBotLimitSell(api, input.params),
    mutationKey: [BOT_LIMIT_SELL_QUERY_KEY],
    onSuccess: async (_data, variables) => {
      setNotifyProps({
        type: "success",
        action: "placeLimitSell",
        params: {
          youSell: variables.notifyParams.youSell,
          tokenSymbol: variables.notifyParams.tokenSymbol,
          youPayNative: variables.notifyParams.youPayNative,
          chainSymbol: variables.notifyParams.chainSymbol,
          limitPrice: variables.notifyParams.limitPrice,
        } as NotificationParams,
      });
    },
    onError: async (_error, variables) => {
      setNotifyProps({
        type: "error",
        action: "placeLimitSell",
        params: {
          youSell: variables.notifyParams.youSell,
          tokenSymbol: variables.notifyParams.tokenSymbol,
          youPayNative: variables.notifyParams.youPayNative,
          chainSymbol: variables.notifyParams.chainSymbol,
          limitPrice: variables.notifyParams.limitPrice,
        } as NotificationParams,
      });
    },
  });
};
export { useBotLimitSellMutation, postBotLimitSell, BOT_LIMIT_SELL_QUERY_KEY };
